/* Babbez — scroll reveal (fail-safe: no JS => nothing hidden) */
(function () {
  var els = document.querySelectorAll('[data-bz]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  for (var i = 0; i < els.length; i++) els[i].classList.add('bz-anim');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px 18% 0px', threshold: 0.01 });
  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();


/* ===== Babbez — collection colour-swatch preview (hover/click swaps the card's main image) ===== */
(function () {
  function mainImg(card) {
    var box = card.querySelector('[data-product-image-default]');
    return box ? box.querySelector('img') : card.querySelector('.product-item__bg img, .product-item__image img');
  }
  function swap(card, url) {
    var img = mainImg(card);
    if (!img || !url) return;
    if (!card.dataset.bzOrig) { card.dataset.bzOrig = img.getAttribute('src') || ''; card.dataset.bzOrigSet = img.getAttribute('srcset') || ''; }
    img.setAttribute('srcset', ''); img.removeAttribute('sizes'); img.setAttribute('src', url);
    card.classList.add('bz-swatching');
  }
  function revert(card) {
    var img = mainImg(card);
    if (img) { if (card.dataset.bzOrig) img.setAttribute('src', card.dataset.bzOrig); if (card.dataset.bzOrigSet) img.setAttribute('srcset', card.dataset.bzOrigSet); }
    card.classList.remove('bz-swatching');
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest ? e.target.closest('.bz-sw') : null; if (!sw) return;
    var card = sw.closest('.product-item'); if (!card) return;
    swap(card, sw.getAttribute('data-bz-img'));
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest ? e.target.closest('.bz-sw') : null; if (!sw) return;
    var card = sw.closest('.product-item'); if (!card || card.dataset.bzLocked) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.product-item') === card && to.closest('.bz-sw')) return;
    revert(card);
  });
  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('.bz-sw') : null; if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.product-item'); if (!card) return;
    swap(card, sw.getAttribute('data-bz-img'));
    card.dataset.bzLocked = '1';
    var sws = card.querySelectorAll('.bz-sw'); for (var i = 0; i < sws.length; i++) sws[i].classList.remove('is-active');
    sw.classList.add('is-active');
    var vurl = sw.getAttribute('data-bz-url');
    if (vurl) { var links = card.querySelectorAll('a.product-link'); for (var j = 0; j < links.length; j++) links[j].setAttribute('href', vurl); }
  });
})();
